import { toast } from 'react-toastify';
import firebase from '../firebase';
import { customAlert } from './alertActions';
import { GET_BLOGS, GET_SINGLE_BLOG } from './types';

export const getBlogs = () => async dispatch => {
	firebase
		.firestore()
		.collection('blogs')
		.orderBy('created_at', 'desc')
		.onSnapshot(query => {
			var tempBlogs = [];
			query.forEach(doc => {
				tempBlogs.push({ id: doc.id, ...doc.data() });
			});
			dispatch({
				type: GET_BLOGS,
				payload: tempBlogs,
			});
		});
};
export const getSignleBlogs = id => async dispatch => {
	firebase
		.firestore()
		.collection('blogs')
		.doc(id)
		.onSnapshot(query => {
			var tempBlogs = { id: query.id, ...query.data() };
			dispatch({
				type: GET_SINGLE_BLOG,
				payload: tempBlogs,
			});
		});
};
export const blogLoader = val => async dispatch => {
	dispatch({
		type: 'BLOG_LOADER',
		payload: val,
	});
};
export const subscribeBlog = email => async dispatch => {
	dispatch(blogLoader(true));
	const response = await firebase
		.firestore()
		.collection('blogs_subscribers')
		.where('email', '==', email)
		.get();
	if (response.docs.length > 0) {
		dispatch(customAlert(true, 'This email is already in use!'));
		setTimeout(() => {
			dispatch(customAlert(false, ''));
		}, 3000);
		// toast.warn('This email is already in use!');
		dispatch(blogLoader(false));
	} else {
		firebase
			.firestore()
			.collection('blogs_subscribers')
			.add({
				email: email,
				created_at: firebase.firestore.Timestamp.now(),
			})
			.then(res => {
				dispatch(customAlert(true, 'Subscribed Successfully'));
				setTimeout(() => {
					dispatch(customAlert(false, ''));
				}, 3000);
				// toast.success('Subscribed Successfully');
				dispatch(blogLoader(false));
			});
	}
};
